import esContent from './buyDomain.es';

export default {
  ...esContent,
};
